import { jsx as _jsx } from "react/jsx-runtime";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createLazyIcon } from "../../../utilities/createLazyIcon.js";
const createStates = (tokens, state) => {
    const { default: defaultState, hover, focus, active } = state;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { "&:focus, &.Mui-focusVisible": Object.assign({}, applyTokens(focus)), "&:hover": Object.assign({}, applyTokens(hover)), "&:active": Object.assign({}, applyTokens(active)) });
};
const accordion = (tokens) => {
    const { accordion } = tokens.component;
    const ExpandDownIcon = createLazyIcon(() => import("@diligentcorp/atlas-react-icons/dist/esm/lens/ExpandDown.js"));
    return {
        MuiAccordion: {
            defaultProps: {
                disableGutters: true,
                square: true,
                elevation: 0,
            },
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(accordion)), { "&:last-of-type": {
                        borderBottom: "none",
                    }, boxShadow: "none", "& .MuiListItemButton-root:hover": {
                        backgroundColor: "initial",
                        color: "initial",
                    } }),
            },
        },
        MuiAccordionSummary: {
            defaultProps: {
                expandIcon: _jsx(ExpandDownIcon, {}),
                "data-atlas-alignment": "start",
            },
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign({}, applyTokens(accordion.summary)), createStates(tokens, {
                    default: accordion.default,
                    hover: accordion.hover,
                    focus: accordion.focus,
                    active: accordion.active,
                })), { 
                    // default align to left
                    flexDirection: "row-reverse", ".MuiAccordionSummary-expandIconWrapper": Object.assign(Object.assign({}, applyTokens(accordion.icon)), { display: "flex", alignItems: "center", justifyContent: "center", transform: "rotate(-90deg)", "&.Mui-expanded": {
                            transform: "rotate(0deg)",
                        } }), ".MuiAccordionSummary-content": {
                        margin: 0,
                    }, 
                    // align to right
                    "[data-atlas-alignment='end'] &": {
                        flexDirection: "row",
                        ".MuiAccordionSummary-content": {
                            justifyContent: "space-between",
                        },
                    } }),
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(accordion.details)), { ".MuiTypography-root": Object.assign({}, applyTokens(accordion.details.typography)) }),
            },
        },
    };
};
export default accordion;
//# sourceMappingURL=accordion.js.map